type BtnTypes = "primary" | "secondary" | "success" | "danger";

interface BtnCallback {
    (): void;
}

export class Button {
    constructor(
        private label: string,
        private btnType: BtnTypes = "primary",
        private callback?: BtnCallback
    ) { }

    render = () => {
        const element = document.createElement("button") as HTMLButtonElement;
        element.type = "button";
        element.classList.add("btn");
        element.classList.add("btn-" + this.btnType);
        element.innerHTML = this.label;
        element.setAttribute("data-bs-dismiss", "modal");
        if (this.callback) {
            element.addEventListener("click", this.callback);
        }

        return element;
    }
}